// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Label$GearCalculator = require("./Label.bs.js");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Field(Props) {
  var children = Props.children;
  var className = Props.className;
  var label = Props.label;
  return React.createElement("div", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "field",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* [] */0
                    ]
                  ])
            }, React.createElement(Label$GearCalculator.make, {
                  children: label
                }), children);
}

var make = Field;

exports.make = make;
/* react Not a pure module */
